import React from "react";

const ProfileFeedbackDone = ({ setFeedbackDone, _ }) => {
  return (
    <div className="contact-us-els contact-us-done">
      <i className="icon-omni-tick-circle" />
      <h3>{_.Thankyou}</h3>
      <p>{_.GetBackShortly}</p>
      <p>
        <span onClick={() => setFeedbackDone(false)}>{_.TellUsMore}</span>
      </p>
    </div>
  );
};

export default ProfileFeedbackDone;
